// Reduce una foto del celular (3-8MB) a un JPEG liviano antes de subirla.
// Las subidas en tamaño completo fallaban con datos móviles o por el límite
// del servidor. 2000px de lado mayor mantiene el texto legible para el OCR.
const MAX_SIDE = 2000;
const QUALITY = 0.85;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });

export const compressImage = async (file, maxSide = MAX_SIDE) => {
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const width = Math.round(img.width * scale);
    const height = Math.round(img.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    // Fondo blanco por si es un PNG con transparencia
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob) return file;
    // Si quedó más pesada, usar la original, salvo WebP: el backend solo acepta JPG/PNG
    const isAccepted = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
    if (blob.size >= file.size && isAccepted) return file;

    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  } catch (error) {
    console.error('No se pudo comprimir la imagen, se usa la original:', error);
    return file;
  }
};

export default compressImage;
